import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';
import { createPricingIllustration, type PricingTierId } from '../ui/pricing-illustrations';

export function renderPricing(target: HTMLElement): void {
  const cards = SITE.pricingTiers.map((tier) =>
    createEl('article', { className: 'sv-price-card' }, [
      createPricingIllustration(tier.id as PricingTierId),
      createEl('p', { className: 'sv-price-card__badge' }, [tier.badge]),
      createEl('p', { className: 'sv-price-card__price' }, [tier.priceLine]),
      createEl('p', { className: 'sv-price-card__highlight' }, [tier.highlight]),
      createEl('p', { className: 'sv-price-card__details' }, [tier.details]),
    ])
  );

  const section = createEl(
    'section',
    {
      className: 'sv-section sv-section--surface sv-pricing-section',
      id: 'costos',
      'aria-labelledby': 'pricing-title',
    },
    [
      createEl('div', { className: 'sv-inner' }, [
        createEl('h2', { className: 'sv-section__title', id: 'pricing-title' }, [SITE.pricingTitle]),
        createEl('p', { className: 'sv-pricing-section__subtitle' }, [SITE.pricingSubtitle]),
        createEl('div', { className: 'sv-pricing-grid' }, cards),
      ]),
    ]
  );

  target.appendChild(section);
}
